export default __webpack_public_path__ + "static/media/SchrittFuerSchritt.ac93d156.jpeg";